// Module
var code = `<div class="jumbotron-surface scene-status-surface">

  <!-- The colour of the scene is the only inline colour of this panel. It is on
       the edge below the head, as on the other panels of the scene. -->
  <div class="jumbotron-panel-head has-scene-colour" ng-style="{'border-bottom-color': \$ctrl.scene.color}">
    <div class="scene-status-head-main" ng-click="\$ctrl.isCollapsed = !\$ctrl.isCollapsed">
      <i class="fas fa-fw scene-status-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': \$ctrl.isCollapsed, 'fa-chevron-down': !\$ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading">Status</span>
      <span class="jumbotron-dot scene-status-dot" ng-class="\$ctrl.isOnline ? 'is-online' : 'is-offline'"
        title="{{\$ctrl.isOnline ? 'Online' : 'Offline'}}"></span>
    </div>
    <div class="scene-status-actions">
      <button type="button" class="btn btn-sm btn-outline-primary" ui-sref="manager.scene-edit({id:\$ctrl.scene.id})"
        aria-label="Scene settings" title="Scene settings">
        <i class="fas fa-cog" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="scene-status-body" ng-show="!\$ctrl.isCollapsed">
    <div class="scene-status-line">
      <span class="jumbotron-dot scene-status-dot" ng-class="\$ctrl.isOnline ? 'is-online' : 'is-offline'"></span>
      <strong class="scene-status-state is-online" ng-if="\$ctrl.isOnline">Online</strong>
      <strong class="scene-status-state is-offline" ng-if="!\$ctrl.isOnline">Offline</strong>
    </div>
    <div class="scene-status-line">
      <span class="jumbotron-kind-label scene-status-label">Version</span>
      <span>{{\$ctrl.scene.version | jumbotronVersionJson}}</span>
    </div>
    <div class="scene-status-line">
      <span class="jumbotron-kind-label scene-status-label">Last seen</span>
      <span>{{\$ctrl.scene.lastSeen | amFromUnix | amDateFormat:'YYYY-MM-DD HH:mm:ss'}}</span>
      <span class="jumbotron-note" am-time-ago="\$ctrl.scene.lastSeen | amFromUnix"></span>
    </div>
  </div>
</div>
`;
// Exports
export default code;